import React, { useContext } from 'react';

import { EarnStackRoutes, EarnStackScreenProps } from '@/features/earn/earn.navigator';
import { ActivityHistoryDetailsWeb } from '@/features/earn/components/cards/ActivityHistoryDetailsWeb';
import { LayoutContext } from 'contexts/LayoutContext';
import { ActivityHistoryDetailsNative } from '@/features/earn/components/cards/ActivityHistoryDetailsNative';
import { UserEarnActionListResponseDataItem } from '../../../../../../../packages/utx-client/src/client';

export interface ActivityHistoryDetailsProps {
  subscription: UserEarnActionListResponseDataItem;
}

export const ActivityHistoryDetails: React.FC<EarnStackScreenProps<EarnStackRoutes.ActivityHistoryDetails>> = ({ route }) => {
  const { subscription } = route.params;

  const layout = useContext(LayoutContext);

  if (layout.isMobile) {
    return <ActivityHistoryDetailsNative subscription={subscription} />;
  }

  return <ActivityHistoryDetailsWeb subscription={subscription} />;
};
